export const openModal = (modalRef) => {
    return {
        type: 'MODAIS_OPEN',
        payload: modalRef
    }
}
export const closeModal = () => {
    return {
        type: 'MODAIS_CLOSE'
    }
}


// WEBPACK FOOTER //
// ./src/modules/actions/Modais.js